import { wa } from 'lib/apps/analytics';
import { noop } from 'utils/func';

export const isAlternativeHeader = (betaFeatures) =>
  !!betaFeatures
  && betaFeatures.includes('ALTERNATIVE_HEADER');

export const reportButtonClick = (description, origin = 'UNKNOWN', callback = noop) => {
  wa.triggerPageEventWithDescription(description, { BUTTON_LOC: origin }, callback);
};
